export default {
  delete: "你确定要删除吗",
  deleteItem: "你确定要删除当前项吗",
  deleteOrder: "你确定要同意删除订单吗",
  cancelOrder: "你确定要同意取消订单吗",
  rejectOrder: "你确定要同意拒绝订单吗",
  executeAction: "你确定要执行该操作吗",
  actionItem: "你确定要{action}当前项吗",
  actionSelected: "你确定要{action}选中项吗",
  actionNamed: "你确定要{action}吗",
};
